'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424 from "./presto.-Dashboard-View$$anon$24.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024 from "./presto.types$-Dashboard-Sign-Stats$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$23() {
  this.aM4 = null;
  this.aLW = null;
  this.aLX = false;
  this.aM5 = null;
  this.aM6 = false;
  this.aM9 = null;
  this.aM2 = null;
  this.aM3 = false;
  this.aLY = null;
  this.aLZ = false;
  this.aM0 = null;
  this.aM1 = false;
  this.aM7 = false;
  this.aM8 = false;
  this.aM4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aM9 = "DashboardSignStats";
}
export { $c_Lpresto_DashboardView$$anon$23 as $c_Lpresto_DashboardView$$anon$23 };
$p = $c_Lpresto_DashboardView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$23;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$23() {
}
export { $h_Lpresto_DashboardView$$anon$23 as $h_Lpresto_DashboardView$$anon$23 };
$h_Lpresto_DashboardView$$anon$23.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aM4;
});
$p.M = (function() {
  if ((!this.aLX)) {
    this.aLW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aLX = true;
  }
  return this.aLW;
});
$p.O = (function() {
  if ((!this.aM6)) {
    this.aM5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aM6 = true;
  }
  return this.aM5;
});
$p.E = (function() {
  return this.aM9;
});
$p.t = (function() {
  if ((!this.aM3)) {
    this.aM2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("signatures", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("envelopes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aM3 = true;
  }
  return this.aM2;
});
$p.N = (function() {
  if ((!this.aLZ)) {
    this.aLY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aLZ = true;
  }
  return this.aLY;
});
$p.Q = (function() {
  if ((!this.aM1)) {
    this.aM0 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424.$c_Lpresto_DashboardView$$anon$24();
    this.aM1 = true;
  }
  return this.aM0;
});
$p.v = (function() {
  if ((!this.aM8)) {
    this.aM7 = false;
    this.aM8 = true;
  }
  return this.aM7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee124) => ((p) => \u03b4scrutinee124.cFS(p)))($j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024.$m_Lpresto_types$DashboardSignStats$())));
});
var $d_Lpresto_DashboardView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$23, "presto.DashboardView$$anon$23", ({
  Hl: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$23 as $d_Lpresto_DashboardView$$anon$23 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$23.js.map
